import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Fab,
  Grid,
  GridSize,
  IconButton,
  LinearProgress,
  Link,
  Paper,
  Skeleton,
  SxProps,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Theme,
  Tooltip,
  Typography,
  createSvgIcon
} from "@mui/material";
import dayjs from "dayjs"; // Import dayjs for date formatting
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  formatAddressObject,
  toTitleCase,
  toUpperCase
} from "../../commonFunctions/CommonFunctions";
// import http from "../../commonFunctions/htttpClientNew";
import { WSIcons } from "../../commonFunctions/iIcons";

import { storeDataComponent } from "../../StateManagement/actions";
import store from "../../StateManagement/store";
// import { IFilter, WSFilterComponent } from "../Filter/WSFilterComponent";
import { WSStatus } from "../Status/WSStatus";
import ThreeDotMenu from "../ThreeDotMenu/ThreeDotMenu";
import { WSView } from "../View/WSView";
import config from "../../Config/config.json";
import { useSnackbar } from "../Snackbar/SnackBarContext";
import { FilterSearchText } from "../Filter/FilterSeacrchText";
import http from "../../commonFunctions/httpClient";
interface DataGridProps {
  id: string;
  title?: string;
  titleSpace?: GridSize;
  columns: IColumns[];
  data?: Array<any>;
  multiSelect?: boolean;
  onSelectionChange?: (selectedRows: any[]) => void;
  source?: {
    url: string;
    pageSize: number;
    page: number;
    filter: any[];
    sort: any[];
    type?: "POST" | "GET";
  };
  filters?: any;
  filterFields?: any;
  clientFilter?: boolean;
  pageSize?: number;
  exportCsv?: boolean;
  addButton?: any;
  transFormData?: (data: any) => any;
  onAddButtonClick?: () => void;
  buttonStyle?: "Normal" | "Fab";
  showpagination?: boolean;
  gridHeaderSx?: SxProps<Theme>;
  handleCheckBoxChangedValues?: (data: Array<any>) => void;
  searchBox?: { fieldName?: string };
  highlight?: boolean;
  mt?:number;
  mb?:number;
}
export interface IColumns {
  header: string;
  fieldName: string;
  type?:
    | "default"
    | "link"
    | { image: { suffix1?: string; suffix2?: string } }
    | "action"
    | "status"
    | "date"
    | "color"
    | "img"
    | "checkbox"
    | "currency"
    | "booleanToString";
  tooltip?: boolean;
  actions?: any;
  defaultSort?: string;
  actionCallback?: (action: string, row: any) => void;
  sortable?: boolean; // Indicate if column is sortable
  sortKey?: string;
  groupType?: string;
}

const WSDataGridForDashboard: React.FC<DataGridProps> = ({
  id,
  columns,
  multiSelect,
  onSelectionChange,
  source,
  filters,
  filterFields,
  clientFilter = false,
  exportCsv = false,
  transFormData,
  title,
  addButton,
  onAddButtonClick,
  buttonStyle = "Normal",
  showpagination = true,
  gridHeaderSx,
  data,
  handleCheckBoxChangedValues,
  searchBox,
  titleSpace,
  pageSize = 5,
  highlight = false,
  mt=0,
  mb=0
}) => {
  const [page, setPage] = useState(0);
  const [_rows, setRows] = useState<any[]>(data || []);
  const [rowsPerPage, setRowsPerPage] = useState<number>(pageSize || 5);
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [selectedRowsForColumn, setSelectedRowsForColumn] = useState<number[]>(
    []
  );
  const [totalCount, setTotalCount] = useState<number>(0);
  const [exporting, setExporting] = useState<boolean>(false);
  const [showImagePopup, setShowImagePopup] = useState<boolean>(false);
  const [popupImageURL, setPopupImageURL] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const gridContainerRef = useRef<HTMLDivElement>(null);
  const [gridHeight, setGridHeight] = useState<any>();
  const [newFilters, setFilters] = useState(filters);
  const [allData, setAllData] = useState<any[]>([]);

  const { showMessage } = useSnackbar();
  const ExportIcon = createSvgIcon(
    <path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z" />,
    "SaveAlt"
  );
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "asc" | "desc";
  }>({
    key: "",
    direction: "desc"
  });

  const dispatch = useDispatch();
  const handleImageClick = (imageUrl: string) => {
    setPopupImageURL(imageUrl);
    setShowImagePopup(true);
  };
  const fetchDataFromAPI = async (
    page: number,
    pageSize: number,
    filter: any[] = [],
    sort: any[] = []
  ) => {
    try {
      setLoading(true);
      if (source?.type === "GET") {
        const response: any = await http.get(source.url);
        return response;
      }
      if (source) {
        const response: any = await http.post(source.url, {
          page: page,
          pageSize: pageSize,
          filter: filter,
          sort: source?.sort?.length > 0 ? source.sort : sort
        });
        console.log("dashboard grid response", response);
        return response;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // End loading
    }
  };

  const loadPageData = useCallback(async () => {
    try {
      const defaultSortKey = columns?.find(
        (column: any) => column?.defaultSort
      );
      const sortKey: any = sortConfig.key
        ? sortConfig.key
        : defaultSortKey
        ? defaultSortKey.defaultSort
        : "";
      const sort = [{ field: sortKey, direction: sortConfig.direction }];
      let filter: any = [];
      if (source && source?.filter?.length > 0) {
        filter = [...source?.filter];
        if (newFilters) {
          filter = [...newFilters];
        }
      }
      let response = await fetchDataFromAPI(
        page + 1,
        rowsPerPage,
        filter && filter?.length > 0 ? filter : newFilters,
        sortKey !== "" ? sort : []
      );

      setAllData(response?.data);
      //if (response && response.data && _rows && _rows.length > 0 && _rows[0].id !== response.data[0].id) {
      dispatch(storeDataComponent(id, response?.data || []));
      //}
      if (transFormData) {
        setRows(transFormData(response?.data || []));
      } else {
        setRows(response?.data || []);
      }
      setTotalCount(response?.pagination?.totalCount | 0);
    } catch (error) {
      console.error("Error loading page data:", error);
    }
  }, [page, rowsPerPage, source, id, sortConfig, newFilters, transFormData]);

  useEffect(() => {
    if (data && data?.length > 0) {
      const startIndex: any = page !== 0 ? page * rowsPerPage : page;
      const paginatedData: any = data.slice(
        startIndex,
        startIndex + rowsPerPage
      );

      setRows(paginatedData);
      //setRows(data);
      setTotalCount(data?.length);
      setAllData(data);

      setRowsPerPage(pageSize || 5);
      dispatch(storeDataComponent(id, data || []));
    } else {
      loadPageData();
      setSelectedRows([]);
    }

    if (gridContainerRef.current) {
      setGridHeight(gridContainerRef.current.clientHeight);
    }
  }, [page, rowsPerPage, sortConfig, newFilters, data]);
  useEffect(() => {
    const unsubscribe = store.subscribe(() => {
      const state = store.getState();
      if (state.components[id]?.data === null) {
        loadPageData();
        setSelectedRows([]);
      }
    });

    return () => {
      unsubscribe();
    };
  }, [id, loadPageData]);
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset page to 0 when rows per page changes
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelectedRows = _rows.map(
        (_, index) => page * rowsPerPage + index
      );
      setSelectedRows(newSelectedRows);
      if (onSelectionChange) {
        onSelectionChange(
          newSelectedRows.map((idx) => _rows[idx % rowsPerPage])
        );
      }
      return;
    }
    setSelectedRows([]);
    if (onSelectionChange) {
      onSelectionChange([]);
    }
  };
  const handleSelectAllClickForColumns = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.checked) {
      const newSelectedRows = _rows.map(
        (_, index) => page * rowsPerPage + index
      );
      setSelectedRowsForColumn(newSelectedRows);
      if (handleCheckBoxChangedValues) {
        handleCheckBoxChangedValues(
          newSelectedRows.map((idx) => _rows[idx % rowsPerPage])
        );
      }
      return;
    }
    setSelectedRowsForColumn([]);
    if (handleCheckBoxChangedValues) {
      handleCheckBoxChangedValues([]);
    }
  };

  const handleClick = (index: number) => {
    const selectedIndex = selectedRows.indexOf(index);

    let newSelectedRows: number[] = [];

    if (selectedIndex === -1) {
      newSelectedRows = newSelectedRows.concat(selectedRows, index);
    } else if (selectedIndex === 0) {
      newSelectedRows = newSelectedRows.concat(selectedRows.slice(1));
    } else if (selectedIndex === selectedRows?.length - 1) {
      newSelectedRows = newSelectedRows.concat(selectedRows.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedRows = newSelectedRows.concat(
        selectedRows.slice(0, selectedIndex),
        selectedRows.slice(selectedIndex + 1)
      );
    }
    setSelectedRows(newSelectedRows);

    if (onSelectionChange) {
      onSelectionChange(newSelectedRows.map((idx) => _rows[idx % rowsPerPage]));
    }
  };
  const handleClickForColumns = (index: number) => {
    const selectedIndexForColumn = selectedRowsForColumn.indexOf(index);

    let newSelectedRowsForColumn: number[] = [];

    if (selectedIndexForColumn === -1) {
      newSelectedRowsForColumn = newSelectedRowsForColumn.concat(
        selectedRowsForColumn,
        index
      );
    } else if (selectedIndexForColumn === 0) {
      newSelectedRowsForColumn = newSelectedRowsForColumn.concat(
        selectedRowsForColumn.slice(1)
      );
    } else if (selectedIndexForColumn === selectedRowsForColumn?.length - 1) {
      newSelectedRowsForColumn = newSelectedRowsForColumn.concat(
        selectedRowsForColumn.slice(0, -1)
      );
    } else if (selectedIndexForColumn > 0) {
      newSelectedRowsForColumn = newSelectedRowsForColumn.concat(
        selectedRowsForColumn.slice(0, selectedIndexForColumn),
        selectedRowsForColumn.slice(selectedIndexForColumn + 1)
      );
    }
    setSelectedRowsForColumn(newSelectedRowsForColumn);

    if (handleCheckBoxChangedValues) {
      handleCheckBoxChangedValues(
        newSelectedRowsForColumn.map((idx) => _rows[idx % rowsPerPage])
      );
    }
  };
  const isSelected = (index: number) => selectedRows.indexOf(index) !== -1;
  const isSelectedForColumn = (index: number) =>
    selectedRowsForColumn.indexOf(index) !== -1;
  const handleRequestSort = (property: string) => {
    const isAsc =
      sortConfig.key?.toLowerCase() === property &&
      sortConfig.direction === "asc";
    setSortConfig({ key: property, direction: isAsc ? "desc" : "asc" });
    setPage(0);
  };

  const sortedRows = () => {
    if (sortConfig.key) {
      const comparator = (a: any, b: any) => {
        if (a[sortConfig.key] < b[sortConfig.key])
          return sortConfig.direction === "asc" ? -1 : 1;
        if (a[sortConfig.key] > b[sortConfig.key])
          return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      };
      return [..._rows].sort(comparator);
    }
    return _rows;
  };

  const isArrayOrObject = (value: any) => {
    return value && typeof value === "object";
  };

  // const handleFilterChange = (newFilters: any) => {
  //   console.log("client filter", clientFilter);
  //   if (!clientFilter) setFilters(newFilters);

  //   if (clientFilter) {
  //     console.log("working  filter please wait fetching all data", allData);

  //     if (!allData || allData.length === 0) return;

  //     const filtered = applyFiltersLocally(allData, newFilters);
  //     console.log("filtered are ", filtered);

  //     dispatch(storeDataComponent(id, filtered || []));
  //     setRows(filtered || []);
  //   }
  // };
  const handleAddButton = () => {
    if (onAddButtonClick) {
      onAddButtonClick();
    }
  };
  const formatExportData = (rows: any[], columns: IColumns[]) => {
    return rows.map((row) => {
      const formattedRow: any = {};
      columns?.forEach((column) => {
        if (column.fieldName.includes("addresses")) {
          const formattedAddress: any = formatAddressObject(
            row[column.fieldName]
          );
          formattedRow[column.fieldName] = `${
            formattedAddress.addressLine1 || ""
          } ${formattedAddress.addressLine2 || ""} ${
            formattedAddress.city || ""
          } ${formattedAddress.state || ""} ${formattedAddress.zipCode || ""}`;
        } else {
          formattedRow[column.fieldName] = row[column.fieldName];
        }
      });
      return formattedRow;
    });
  };

  const handleExportCSV = async () => {
    setExporting(true);
    const exportData = formatExportData(_rows, columns);
    const csvContent = [
      columns?.map((column) => column.header).join(","),
      ...exportData.map((row) =>
        columns?.map((column) => `"${row[column.fieldName] || ""}"`).join(",")
      )
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `${id}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setExporting(false);
  };
  const handleSearchBoxFilterChange = (updatedFilters: any[]) => {
    console.log("updated filter is", updatedFilters);
    setFilters(updatedFilters);
  };
  const boolenToStringConvert = (value: any) => {
    const newValue: boolean = Boolean(value);
    return newValue === true ? "Yes" : "No";
  };

  // const applyFiltersLocally = (data: any[], filters: IFilter[]) => {
  //   console.log("dta is ", data);
  //   console.log("filters are", filters);

  //   const parseDMY = (dateStr: string) => {
  //     const [day, month, year] = dateStr.split("/");
  //     return new Date(`${year}-${month}-${day}`);
  //   };

  //   return data.filter((item) => {
  //     return filters.every((filter) => {
  //       const fieldVal = getNestedValue(item, filter.field);
  //       const filterVal = filter.value;
  //       console.log("field vale is", fieldVal);
  //       switch (filter.operator) {
  //         case "eq": {
  //           if (typeof fieldVal === "boolean") {
  //             return fieldVal === (String(filterVal).toLowerCase() === "true");
  //           }
  //           return (
  //             String(fieldVal).toLowerCase() === String(filterVal).toLowerCase()
  //           );
  //         }

  //         case "bitween":
  //           const [from, to] = String(filter.value).split(",");
  //           const fromDate = parseDMY(from);
  //           const toDate = parseDMY(to);
  //           const itemDate = new Date(fieldVal);

  //           return (
  //             itemDate instanceof Date &&
  //             !isNaN(itemDate.getTime()) &&
  //             itemDate >= fromDate &&
  //             itemDate <= toDate
  //           );

  //         case "lt": {
  //           const targetDate = parseDMY(String(filterVal));
  //           const itemDate = new Date(fieldVal);
  //           return itemDate < targetDate;
  //         }

  //         case "gt": {
  //           const targetDate = parseDMY(String(filterVal));
  //           const itemDate = new Date(fieldVal);
  //           return itemDate > targetDate;
  //         }

  //         default:
  //           return true;
  //       }
  //     });
  //   });
  // };

  // const getNestedValue = (obj: any, path: string): any => {
  //   return path.split(".").reduce((o, key) => {
  //     if (o && typeof o === "object" && key in o) {
  //       return o[key];
  //     } else {
  //       console.warn(`Key "${key}" not found in`, o);
  //       return undefined;
  //     }
  //   }, obj);
  // };

  return (
    <div className="data-grid-container" ref={gridContainerRef}>
      <Grid item container spacing={1} justifyContent={"start"} mt={mt} mb={mb}>
        <Grid item sm={12} xs={12}>
          <Paper style={{ width: "100%" }}>
            <Grid
              item
              container
              spacing={1}
              justifyContent={"start"}
              sx={{
                marginTop: 0,
                marginLeft: 0,
                width: "100%",
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
                ...gridHeaderSx
              }}
            >
              {title && (
                <Grid
                  alignContent={"center"}
                  style={{ paddingLeft: 20, paddingTop: 0, height: "4rem" }}
                  item
                  sm={titleSpace || 4}
                  className="ws-data-grid ws-data-grid-title"
                >
                  <Typography
                    variant="h6"
                    id="tableTitle"
                    sx={{ fontSize: "1rem" }}
                  >
                    {title}
                  </Typography>
                </Grid>
              )}
              {!title && (
                <Grid
                  style={{ paddingLeft: 20, paddingTop: 25, height: "4rem" }}
                  item
                  sm={4}
                  className="ws-data-grid ws-data-grid-title"
                ></Grid>
              )}
              <Grid item sm={8} container spacing={2} justifyContent={"end"}>
                {searchBox && (
                  <Grid item sx={{ paddingRight: 2 }} style={{ paddingTop: 0 }}>
                    {" "}
                    <FilterSearchText
                      defaultFilter={source?.filter}
                      rows={{ fieldName: searchBox?.fieldName || "" }}
                      onFilterChange={handleSearchBoxFilterChange}
                    />
                  </Grid>
                )}
                {addButton && (
                  <Grid item style={{ paddingTop: 25 }}>
                    {buttonStyle === "Normal" && (
                      <IconButton
                        sx={{
                          backgroundColor: "#404040",
                          borderRadius: 1,
                          //padding: '8px',
                          width: "38px",
                          height: "32px",
                          display: "flex",
                          alignItems: "center",
                          marginRight: !exportCsv || !addButton ? 1 : 0,
                          justifyContent: "center",
                          "&:hover": {
                            backgroundColor: "#606060" // Change the color on hover
                            //transform: 'scale(1.05)', // Optional: Slightly scale up the button on hover
                          }
                        }}
                        onClick={handleAddButton}
                      >
                        <WSIcons.AddIcon style={{ color: "white" }} />
                      </IconButton>
                    )}
                    {buttonStyle === "Fab" && (
                      <Fab
                        size="small"
                        onClick={handleAddButton}
                        sx={{
                          backgroundColor: "#404040",
                          "&:hover": {
                            backgroundColor: "#606060"
                          },
                          height: 32
                        }}
                        aria-label="add"
                      >
                        <WSIcons.AddIcon style={{ color: "white" }} />
                      </Fab>
                    )}
                  </Grid>
                )}
                {exportCsv && (
                  <Grid
                    item
                    sx={{ paddingRight: !filterFields ? 2 : undefined }}
                    style={{ paddingTop: 25 }}
                  >
                    {buttonStyle === "Normal" && (
                      <Button
                        sx={{
                          height: "32px",
                          fontSize: "0.75rem"
                        }}
                        variant="contained"
                        color="primary"
                        startIcon={<ExportIcon />}
                        onClick={handleExportCSV}
                        disabled={exporting}
                      >
                        Export
                      </Button>
                    )}
                    {buttonStyle === "Fab" && (
                      <Fab
                        sx={{ height: 32 }}
                        variant="extended"
                        size="medium"
                        color="primary"
                        onClick={handleExportCSV}
                      >
                        <ExportIcon sx={{ mr: 1 }} />
                        Export
                      </Fab>
                    )}
                  </Grid>
                )}

                {filterFields && (
                  <Grid
                    item
                    sx={{ paddingRight: 2 }}
                    style={{ paddingTop: 25 }}
                  >
                    {/* <WSFilterComponent
                      defaultFilter={source?.filter}
                      rows={filterFields}
                      alignment="right"
                      onFilterChange={handleFilterChange}
                    ></WSFilterComponent> */}
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Divider style={{ marginTop: 0 }} />

            <Table size="small">
              <TableHead>
                <TableRow component="th">
                  {multiSelect && (
                    <TableCell padding="checkbox">
                      <Checkbox
                        indeterminate={
                          totalCount > rowsPerPage
                            ? selectedRows?.length > 0 &&
                              selectedRows?.length < rowsPerPage
                            : selectedRows?.length > 0 &&
                              selectedRows?.length < totalCount
                        }
                        checked={
                          totalCount > rowsPerPage
                            ? selectedRows?.length === rowsPerPage
                            : totalCount > 0 &&
                              selectedRows?.length === totalCount
                        }
                        onChange={handleSelectAllClick}
                        inputProps={{ "aria-label": "select all rows" }}
                      />
                    </TableCell>
                  )}

                  {columns?.map((column, index) => (
                    <TableCell
                      className="ws-data-grid-header"
                      key={index}
                      sortDirection={
                        sortConfig.key?.toLowerCase() ===
                        column?.fieldName?.toLowerCase()
                          ? sortConfig.direction
                          : false
                      }
                    >
                      {/* {column.type === 'checkbox' && (
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        indeterminate={
                                                            selectedRowsForColumn?.length > 0 && selectedRowsForColumn?.length < rowsPerPage
                                                        }
                                                        checked={selectedRowsForColumn?.length === rowsPerPage}
                                                        id={`chk-new-header${index}`}
                                                        name={`chk-new-header${index}`}
                                                        onChange={handleSelectAllClickForColumns}
                                                        inputProps={{ 'aria-label': 'select all rows' }}
                                                    />
                                                </TableCell>
                                            )} */}
                      {column.sortable ? (
                        <TableSortLabel
                          active={
                            sortConfig.key?.toLowerCase() ===
                            column.fieldName.toLowerCase()
                          }
                          direction={
                            sortConfig.key?.toLowerCase() ===
                            column.fieldName.toLowerCase()
                              ? sortConfig.direction
                              : "asc"
                          }
                          onClick={() =>
                            handleRequestSort(
                              column.sortKey ? column.sortKey : column.fieldName
                            )
                          }
                        >
                          {toUpperCase(column.header)}
                        </TableSortLabel>
                      ) : (
                        toUpperCase(column.header)
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {sortedRows()?.length > 0 ? (
                <TableBody>
                  {loading ? (
                    <>
                      {/* Progress bar at the top */}
                      {/* <Grid
                                    display="block"
                                    width="100%"
                                    justifyContent="center"
                                    alignItems="center"
                                    minHeight={400}
                                    
                                >
                                    <LinearProgress />
                                </Grid> */}

                      {/* Skeleton and loading indication */}
                      <TableRow component="th">
                        <TableCell
                          colSpan={columns?.length + (multiSelect ? 1 : 0)}
                          align="center"
                        >
                          <Box
                            display="flex"
                            width="100%"
                            justifyContent="center"
                            alignItems="center"
                            minHeight={gridHeight - 200} // Adjust the height based on your grid size
                          >
                            <Grid
                              container
                              spacing={2}
                              width="90%"
                              justifyContent="center"
                              alignItems="center"
                            >
                              <Grid item sm={12}>
                                {/* Skeleton loader as a placeholder */}
                                <Skeleton width="100%">
                                  <Typography>.</Typography>
                                </Skeleton>

                                {/* Rectangular skeleton */}
                                <Skeleton
                                  animation="pulse"
                                  variant="rectangular"
                                  width="100%"
                                >
                                  <div style={{ paddingTop: "17%" }} />
                                </Skeleton>

                                <Skeleton width="100%">
                                  <Typography>.</Typography>
                                </Skeleton>
                              </Grid>
                            </Grid>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </>
                  ) : (
                    sortedRows().map((row: any, index: number) => {
                      const isItemSelected = isSelected(
                        page * rowsPerPage + index
                      );
                      const isItemSelectedForColumn = isSelectedForColumn(
                        page * rowsPerPage + index
                      );

                      const labelId = `enhanced-table-checkbox-${index}`;
                      const labelIdisItemSelectedForColumn = `enhanced-table-checkbox-isItemSelectedForColumn${index}`;
                      return (
                        <TableRow
                          hover
                          onClick={() =>
                            handleClick(page * rowsPerPage + index)
                          }
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.id}
                          selected={isItemSelected}
                          style={{
                            backgroundColor: row.highlight
                              ? "#d4edda"
                              : "inherit" // 💚 Highlight only if highlight is true
                          }}
                        >
                          {multiSelect && (
                            <TableCell padding="checkbox">
                              <Checkbox
                                id={`chk-sel${index}`}
                                checked={isItemSelected}
                                inputProps={{ "aria-labelledby": labelId }}
                              />
                            </TableCell>
                          )}
                          {columns?.map((column, colIndex) => {
                            if (
                              column.type === "default" &&
                              column.tooltip === true
                            ) {
                              return (
                                <TableCell key={colIndex}>
                                  <WSView
                                    style={{ fontSize: "0.875rem" }}
                                    title={row[column.fieldName]}
                                    isTooltip={column.tooltip}
                                  />
                                </TableCell>
                              );
                            } else if (column.type === "link") {
                              return (
                                <TableCell key={colIndex}>
                                  <Link
                                    href={row[column.fieldName]}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {row[column.fieldName]}
                                  </Link>
                                </TableCell>
                              );
                            } else if (
                              typeof column.type === "object" &&
                              column.type.image
                            ) {
                              return (
                                <TableCell key={colIndex}>
                                  <Grid item container spacing={3}>
                                    <Grid item sm={4}>
                                      <img
                                        src={row[column.fieldName]}
                                        alt="thumbnail"
                                        onClick={() =>
                                          handleImageClick(
                                            row[column.fieldName]
                                          )
                                        }
                                        style={{
                                          cursor: "pointer",
                                          maxWidth: "100px",
                                          height: "40px"
                                        }}
                                      />
                                    </Grid>
                                    {column.type.image.suffix1 && (
                                      <Grid item sm={4}>
                                        <Typography
                                          style={{
                                            fontSize: "12px",
                                            paddingTop: !column.type?.image
                                              ?.suffix2
                                              ? "10px"
                                              : "0"
                                          }}
                                        >
                                          {row[column.type.image.suffix1]}
                                        </Typography>
                                        {column.type?.image?.suffix2 && (
                                          <Typography
                                            style={{ fontSize: "9px" }}
                                          >
                                            {row[column.type?.image?.suffix2]}
                                          </Typography>
                                        )}
                                      </Grid>
                                    )}
                                  </Grid>
                                </TableCell>
                              );
                            } else if (column.type === "status") {
                              return (
                                <TableCell key={colIndex}>
                                  <WSStatus value={row[column.fieldName]} />
                                </TableCell>
                              );
                            }
                            // else if (column.type === 'checkbox') {
                            //     return (
                            //         <TableCell key={colIndex}>

                            //             <Checkbox id={`chkcolumn-${index}`} name={`chk-${index}`}
                            //                 checked={isItemSelectedForColumn}
                            //                 onClick={() => handleClickForColumns(page * rowsPerPage + index)}
                            //                 inputProps={{ 'aria-labelledby': labelIdisItemSelectedForColumn }}
                            //             />
                            //         </TableCell>
                            //     );
                            // }
                            else if (column.type === "img") {
                              return (
                                <TableCell key={colIndex}>
                                  <Grid item container spacing={3}>
                                    <Grid item sm={4}>
                                      <Tooltip
                                        title={
                                          <>
                                            {" "}
                                            <img
                                              src={`${config.imgUrl}${
                                                row[column.fieldName]
                                              }`}
                                              alt="thumbnail"
                                              style={{
                                                cursor: "pointer",
                                                width: "200px",
                                                height: "150px"
                                              }}
                                            />
                                          </>
                                        }
                                      >
                                        <img
                                          src={`${config.imgUrl}${
                                            row[column.fieldName]
                                          }`}
                                          alt="thumbnail"
                                          onClick={() =>
                                            window.open(
                                              `${config.imgUrl}${
                                                row[column.fieldName]
                                              }`,
                                              "_blank"
                                            )
                                          }
                                          style={{
                                            cursor: "pointer",
                                            width: "50px",
                                            height: "40px"
                                          }}
                                        />
                                      </Tooltip>
                                    </Grid>
                                  </Grid>
                                </TableCell>
                              );
                            } else if (column.type === "color") {
                              return (
                                <TableCell key={colIndex}>
                                  <Box display="flex" alignItems="center">
                                    <Avatar
                                      sx={{
                                        bgcolor: row[column.fieldName]
                                          ? row[column.fieldName]
                                          : "gray",
                                        width: 24,
                                        height: 24,
                                        marginRight: 1,
                                        fontSize: "0.75rem"
                                      }}
                                      variant="rounded"
                                      defaultValue={""}
                                    >
                                      <></>
                                    </Avatar>
                                    <Typography
                                      onDoubleClick={() => {
                                        const textToCopy = toTitleCase(
                                          row[column.fieldName] || ""
                                        );
                                        navigator.clipboard
                                          .writeText(textToCopy)
                                          .then(() => {
                                            showMessage(
                                              `Copied: ${textToCopy}`,
                                              "success"
                                            );
                                          });
                                      }}
                                    >
                                      {toTitleCase(row[column.fieldName])}
                                    </Typography>
                                  </Box>
                                </TableCell>
                              );
                            } else if (column.type === "date") {
                              return (
                                <TableCell key={colIndex}>
                                  <Typography style={{ fontSize: "0.875rem" }}>
                                    {dayjs(row[column.fieldName]).isValid()
                                      ? dayjs(row[column.fieldName]).format(
                                          "DD/MM/YYYY"
                                        )
                                      : "Invalid Date"}
                                  </Typography>
                                </TableCell>
                              );
                            } else if (column.type === "currency") {
                              return (
                                <TableCell key={colIndex}>
                                  <Typography style={{ fontSize: "0.875rem" }}>
                                    ₹{row[column.fieldName]}
                                  </Typography>
                                </TableCell>
                              );
                            } else if (column.type === "booleanToString") {
                              return (
                                // <TableCell key={colIndex}>
                                //     <Typography style={{ fontSize: '0.875rem' }}>
                                //         {boolenToStringConvert(row[column.fieldName])}
                                //     </Typography>
                                // </TableCell>
                                <TableCell
                                  key={colIndex}
                                  style={{
                                    fontSize: "0.875rem",
                                    backgroundColor: row.highlight
                                      ? "#d4edda"
                                      : "inherit" // 💚 Cell highlight
                                  }}
                                >
                                  <Typography style={{ fontSize: "0.875rem" }}>
                                    {boolenToStringConvert(
                                      row[column.fieldName]
                                    )}
                                  </Typography>
                                </TableCell>
                              );
                            }
                            // else if (column.type === 'date') {
                            //     return (
                            //         <TableCell key={colIndex}>
                            //             <Typography  style={{fontSize:'0.875rem'}} >{dayjs(row[column.fieldName])?.toDate().toLocaleDateString()}</Typography>
                            //         </TableCell>
                            //     );
                            // }
                            else if (
                              column.type === "action" &&
                              column?.actions?.length > 0
                            ) {
                              return (
                                <TableCell key={colIndex}>
                                  <ThreeDotMenu
                                    items={column.actions}
                                    onAction={(action: string) =>
                                      column.actionCallback?.(action, row)
                                    }
                                  />
                                </TableCell>
                              );
                            } else {
                              return (
                                <TableCell key={colIndex}>
                                  {isArrayOrObject(row[column.fieldName])
                                    ? JSON.stringify(row[column.fieldName])
                                    : row[column.fieldName]}
                                </TableCell>
                              );
                            }
                          })}
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              ) : loading ? (
                <>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        colSpan={columns?.length + (multiSelect ? 1 : 0)}
                        align="center"
                      >
                        <Box
                          display="block"
                          width="100%"
                          justifyContent="center"
                          alignItems="center"
                          minHeight={400}
                        >
                          <LinearProgress />
                        </Box>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                  {/* <Box
                                    display="block"
                                    width="100%"
                                    justifyContent="center"
                                    alignItems="center"
                                    minHeight={400}
                                >
                                    <LinearProgress />
                                </Box> */}

                  {/* Skeleton and loading indication */}
                </>
              ) : (
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={columns?.length + (multiSelect ? 1 : 0)}
                      align="center"
                    >
                      <Typography
                        variant="h6"
                        style={{ padding: "20px", fontSize: "1rem" }}
                      >
                        No Records to Show
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
            {/* )} */}
            {showpagination === true && (
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            )}
          </Paper>
        </Grid>
      </Grid>
      <Dialog
        open={showImagePopup}
        onClose={() => setShowImagePopup(false)}
        maxWidth="xs"
      >
        <DialogTitle>Image</DialogTitle>
        <DialogContent>
          <img
            src={popupImageURL}
            alt="Large Preview"
            style={{ maxWidth: "100%" }}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default WSDataGridForDashboard;
